module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("时间规则")]), _vm._v(" "), _c('p', [_vm._v("请谨慎点击,保存后会修改库存!")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('rule')
      }
    }
  }, [_vm._v("新增+")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("24小时制，如10：00-20：30")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.rule), function(item, index) {
    return _c('el-card', {
      key: item.key,
      staticClass: "box-card"
    }, [(index > 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'rule')
        }
      }
    }, [_vm._v("移除X")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": '执行类型',
        "prop": 'rule.' + index + '.type'
      }
    }, [_c('el-radio', {
      attrs: {
        "size": "mini",
        "label": "time",
        "border": ""
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_vm._v("按每日时间执行")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "size": "mini",
        "label": "date",
        "border": ""
      },
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_vm._v("按选择日期执行")])], 1), _vm._v(" "), _c('div', [(item.type == 'date') ? _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '起始日期',
        "prop": 'rule.' + index + '.start_date'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "size": "mini",
        "type": "date",
        "placeholder": "起始日期"
      },
      model: {
        value: (item.start_date),
        callback: function($$v) {
          _vm.$set(item, "start_date", $$v)
        },
        expression: "item.start_date"
      }
    })], 1) : _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '起始时间',
        "prop": 'rule.' + index + '.start',
        "rules": [{
          required: true,
          message: '起始时间不能为空'
        } ]
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "mini",
        "picker-options": {
          start: '00:00',
          step: '00:01',
          end: '23:59'
        },
        "placeholder": "请输入起始时间"
      },
      model: {
        value: (item.start),
        callback: function($$v) {
          _vm.$set(item, "start", $$v)
        },
        expression: "item.start"
      }
    })], 1), _vm._v(" "), (item.type == 'date') ? _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '终止日期',
        "prop": 'rule.' + index + '.end_date'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "size": "mini",
        "type": "date",
        "placeholder": "选择日期"
      },
      model: {
        value: (item.end_date),
        callback: function($$v) {
          _vm.$set(item, "end_date", $$v)
        },
        expression: "item.end_date"
      }
    })], 1) : _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '终止时间',
        "prop": 'rule.' + index + '.end',
        "rules": [{
          required: true,
          message: '终止时间不能为空'
        } ]
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "mini",
        "picker-options": {
          start: '00:00',
          step: '00:01',
          end: '23:59'
        },
        "placeholder": "请输入终止时间"
      },
      model: {
        value: (item.end),
        callback: function($$v) {
          _vm.$set(item, "end", $$v)
        },
        expression: "item.end"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap"
      }
    }, _vm._l((_vm.options), function(val, i) {
      return _c('div', {
        key: i,
        staticStyle: {
          "display": "inline-block",
          "width": "25%"
        }
      }, [_c('el-form-item', {
        attrs: {
          "label": val.title
        }
      }, [_c('el-input', {
        attrs: {
          "size": "mini",
          "type": "text",
          "maxlength": "5",
          "show-word-limit": "",
          "placeholder": "请输入数量"
        },
        model: {
          value: (item.number[i].value),
          callback: function($$v) {
            _vm.$set(item.number[i], "value", _vm._n($$v))
          },
          expression: "item.number[i].value"
        }
      })], 1)], 1)
    }), 0)], 1)
  }), 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('form')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cc911a1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc911a1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/setRandCardRule.vue
// module id = 2932
// module chunks = 0